<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn icon="mdi-plus" v-bind="props"></v-btn>
      </template>
      <v-list>
        <v-list-item @click="showNewExpenseGroupModal = true" id="show-modal" class="add-expenses-link">
          <v-list-item-title>group</v-list-item-title>
        </v-list-item>
        <v-list-item @click="showNewExpenseCategoryModal = true" id="show-modal" class="add-expenses-link">
          <v-list-item-title>category</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-row>

  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-text>
          <v-table v-if="expenses.expense_groups">
            <thead>
              <tr>
                <th></th>
                <th class="table-heading-text text-center">annual budget</th>
                <th class="table-heading-text text-center">current trend</th>
                <th class="table-heading-text text-center">last 12 months</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="expense_group in expenses.expense_groups" :key="expense_group.id">
                <tr>
                  <td class="text-left table-heading-text" @click="showEditExpenseGroupModal(expense_group)">{{ expense_group.identifier }}</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr v-for="expense_category in expense_group.expense_categories" :key="expense_category.id">
                  <td class="text-left indent-5" @click="showEditExpenseCategoryModal(expense_category)">{{ expense_category.identifier }}</td>
                  <td class="text-center" @click="showEditExpenseCategoryModal(expense_category)">{{ expense_category.annual_budget.toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
                  <td @click="routeToExpenseTxnsView(expense_category, expense_category.minimum_months_reporting)" class="trend-cell text-center">
                    <template v-if="expense_category.tracking.run_rate_pct != null">
                      <div class="trend-period">{{ expense_category.minimum_months_reporting }} {{ expense_category.minimum_months_reporting === 1 ? 'month' : 'months' }}</div>
                      <div class="trend-amounts">${{ formatAmount(expense_category.tracking.run_rate) }} / ${{ formatAmount(expense_category.tracking.run_rate_budget) }}</div>
                      <div class="trend-bar-row">
                        <div class="trend-bar-track">
                          <div class="trend-bar-fill" :class="getBarColour(expense_category.tracking.run_rate_pct)" :style="{ width: Math.min(expense_category.tracking.run_rate_pct, 100) + '%' }"></div>
                        </div>
                        <span :class="getTextColourForExpensePercentages(expense_category.tracking.run_rate_pct)" class="trend-pct">{{ expense_category.tracking.run_rate_pct }}%</span>
                      </div>
                    </template>
                  </td>
                  <td @click="routeToExpenseTxnsView(expense_category, 12)" class="trend-cell text-center">
                    <template v-if="expense_category.tracking.last_12_months_pct != null">
                      <div class="trend-period">12 months</div>
                      <div class="trend-amounts">${{ formatAmount(expense_category.tracking.last_12_months) }} / ${{ formatAmount(expense_category.tracking.last_12_months_budget) }}</div>
                      <div class="trend-bar-row">
                        <div class="trend-bar-track">
                          <div class="trend-bar-fill" :class="getBarColour(expense_category.tracking.last_12_months_pct)" :style="{ width: Math.min(expense_category.tracking.last_12_months_pct, 100) + '%' }"></div>
                        </div>
                        <span :class="getTextColourForExpensePercentages(expense_category.tracking.last_12_months_pct)" class="trend-pct">{{ expense_category.tracking.last_12_months_pct }}%</span>
                      </div>
                    </template>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-decoration-overline text-center">{{ expense_group.total_annual_budget.toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
                  <td></td>
                  <td></td>
                </tr>
              </template>
              <tr class="">
                <td></td>
                <td class="grand-total-text font-weight-bold padding-top-10 text-center">{{ Number(expenses.total_annual_budget).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
                <td></td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>





  <!--
  <table>
    <tr>
      <th></th>
      <th class="table-heading-text">annual budget</th>
      <th class="table-heading-text">Run Rate</th>
      <th class="table-heading-text">Year To Date</th>
      <th class="table-heading-text">Last 12 Months</th>
    </tr>
    <template v-for="expense_group in expenses.expense_groups" :key="expense_group.id">
      <tr>
        <td class="text-left table-heading-text" @click="showEditExpenseGroupModal(expense_group)">{{ expense_group.identifier }}</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr v-for="expense_category in expense_group.expense_categories" :key="expense_category.id">
        <td class="text-left indent-5" @click="showEditExpenseCategoryModal(expense_category)">{{ expense_category.identifier }}</td>
        <td class="" @click="showEditExpenseCategoryModal(expense_category)">{{ expense_category.annual_budget.toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
        <td :class="getTextColourForExpensePercentages(expense_category.tracking.run_rate_pct)" @click="routeToExpenseTxnsView(expense_category)">{{ (expense_category.tracking.run_rate_pct != null) ? (expense_category.tracking.run_rate_pct + '%') : '' }}</td>
        <td :class="getTextColourForExpensePercentages(expense_category.tracking.year_to_date_pct)" @click="routeToExpenseTxnsView(expense_category)">{{ expense_category.tracking.year_to_date_pct ? (expense_category.tracking.year_to_date_pct + '%') : '' }}</td>
        <td @click="routeToExpenseTxnsView(expense_category)">{{ expense_category.tracking.last_12_months ? (expense_category.tracking.last_12_months + ' /') : '' }}</td>
      </tr>
      <tr>
        <td></td>
        <td class="text-decoration-overline">{{ expense_group.total_annual_budget.toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </template>
    <tr class="">
      <td></td>
      <td class="grand-total-text font-weight-bold padding-top-10">{{ Number(expenses.total_annual_budget).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</td>
      <td></td>
    </tr>
  </table>
  -->
  
  <!-- Modals-->
  <ExpenseGoupNewModalPopup :show="showNewExpenseGroupModal" @close="showNewExpenseGroupModal = false"></ExpenseGoupNewModalPopup> <!-- add a new record -->
  <ExpenseCategoryNewModalPopup :show="showNewExpenseCategoryModal" @close="showNewExpenseCategoryModal = false"></ExpenseCategoryNewModalPopup> <!-- add a new record -->

  <ExpenseGroupEditModalPopup :show="showEditExpenseGroupModalToggle" :currentRow="selectedRow" @close="showEditExpenseGroupModalToggle = false"></ExpenseGroupEditModalPopup> <!--edit a record -->
  <ExpenseCategoryEditModalPopup :show="showEditExpenseCategoryModalToggle" :currentRow="selectedRow" @close="showEditExpenseCategoryModalToggle = false"></ExpenseCategoryEditModalPopup> <!--edit a record -->


</template>

<script>
import axios from 'axios';
import ExpenseGoupNewModalPopup from './modals/ExpenseGoupNewModalPopup.vue';
import ExpenseCategoryNewModalPopup from './modals/ExpenseCategoryNewModalPopup.vue';
import ExpenseGroupEditModalPopup from './modals/ExpenseGroupEditModalPopup.vue';
import ExpenseCategoryEditModalPopup from './modals/ExpenseCategoryEditModalPopup.vue';
import { mapState, mapMutations} from 'vuex';

export default {
  components: {
    ExpenseGoupNewModalPopup,
    ExpenseCategoryNewModalPopup,
    ExpenseGroupEditModalPopup,
    ExpenseCategoryEditModalPopup
  },
  data() {
    return {
      expenses: [],
      showNewExpenseGroupModal: false,
      showNewExpenseCategoryModal: false,
      showEditExpenseGroupModalToggle: false,
      showEditExpenseCategoryModalToggle: false,
      selectedRow: {}
    };
  },
  async created() {
    this.getExpenses();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'expenses',
          disabled: true,
          href: ''
        },
      ];
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    showEditExpenseGroupModal(row){
     this.selectedRow=row;
     this.showEditExpenseGroupModalToggle = true;
    },
    showEditExpenseCategoryModal(row){
     this.selectedRow=row;
     this.showEditExpenseCategoryModalToggle = true;
    },
    async getExpenses(){
      try {
      const response  = await axios.get("/expenses/categories/bygroup/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
          this.expenses = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load expense categories' });
      }
    },
    getTextColourForExpensePercentages(value){
      if(value <= 100){
        return 'green_text';
      }
      else if(value > 100){
        return 'red_text';
      }
    },
    formatAmount(value) {
      return Number(value).toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },
    getBarColour(value) {
      return value <= 100 ? 'green-bar' : 'red-bar';
    },
    routeToExpenseTxnsView(expense_category, months){
      this.$router.push({ path: '/expensetxns/' + expense_category.id, query: { months } })
    },
  }
};
</script>


<style scoped>
table{
  width: 100%;
}

table tr{
  cursor: pointer;
}

.operations-container{
  float: right;
  margin-right: 10px;
  margin-bottom: 10px;
}

.empty-cell{
  height:10px; 
}

.indent-5{
  padding-left: 5px !important;
}

.padding-top-10{
  padding: 10px !important;
}

.grand-total-text{
  font-size: 1.3rem;
}

.add-expenses-link{
    font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif;
    cursor: pointer;
}


.green_text{
  color: green;
}

.red_text{
  color: red;
}

.trend-cell {
  min-width: 180px;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.trend-period {
  font-size: 0.75rem;
  color: #888;
  margin-bottom: 2px;
}

.trend-amounts {
  font-size: 0.85rem;
  margin-bottom: 4px;
}

.trend-bar-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.trend-bar-track {
  flex: 1;
  height: 6px;
  background: #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
}

.trend-bar-fill {
  height: 100%;
  border-radius: 3px;
}

.green-bar {
  background-color: green;
}

.red-bar {
  background-color: red;
}

.trend-pct {
  font-size: 0.9rem;
  white-space: nowrap;
  min-width: 40px;
}

.table-heading-text{
  font-size: 1.5rem;
  font-weight: 300;
}

.table-content-text{
  font-size: 1.2rem;
}

</style>